import { Pipe, PipeTransform } from '@angular/core';
import { getTabsToSpaces } from './text.functions';

@Pipe({
  name: 'tabsToSpaces'
})
export class TextTabsToSpacesPipe implements PipeTransform {
    transform(val, spaces?): string {
        return getTabsToSpaces(val, spaces);
    }
};